import React from 'react'
import { withTranslation } from 'react-i18next'
import { PageHeading } from '../components/Fragments'



function Instructions({ t }) {
  return (
    <>
      <PageHeading pageTitle='menu.instructions' acronym='acronym' researchCenter='cavas_research_center' />

      <p className="uk-text-lead">{t('pages.instructions.part1')}</p>
      <p>{t('pages.instructions.part2')}</p>
      <ul>
        <li>{t('pages.instructions.part3')}</li>
        <li>{t('pages.instructions.part4')}</li>
      </ul>
      <p>{t('pages.instructions.part5')}</p>
      <p>{t('pages.instructions.part6')}</p>
      <p>{t('pages.instructions.part7')}</p>
      <p>{t('pages.instructions.part8')}</p>
      <p>{t('pages.instructions.part9')}</p>
      <p>{t('pages.instructions.part10')}</p>
      <p>{t('pages.instructions.part11')}</p>
      <ul>
        <li>{t('pages.instructions.part12')}</li>
        <li>{t('pages.instructions.part13')}</li>
        <li>{t('pages.instructions.part14')}</li>
      </ul>
      <p>{t('pages.instructions.part15')}</p>
    </>
  )
}

export default withTranslation()(Instructions)
